import { Preferences } from '@capacitor/preferences';
import type { TokenStore } from './token-store';

const REFRESH_KEY = 'lance.refresh';

/**
 * Native (iOS/Android) implementation. Capacitor cannot persist HttpOnly cookies
 * cross-origin (capacitor://localhost ≠ http://api), so the refresh token is
 * returned in the JSON response body and stashed in @capacitor/preferences
 * (iOS Keychain / Android EncryptedSharedPreferences under the hood).
 */
export class CapacitorTokenStore implements TokenStore {
  private accessToken: string | null = null;

  getAccessToken(): string | null {
    return this.accessToken;
  }

  setAccessToken(token: string | null): void {
    this.accessToken = token;
  }

  async getRefreshToken(): Promise<string | null> {
    const { value } = await Preferences.get({ key: REFRESH_KEY });
    return value ?? null;
  }

  async setRefreshToken(token: string | null): Promise<void> {
    if (token === null || token === '') {
      await Preferences.remove({ key: REFRESH_KEY });
      return;
    }
    await Preferences.set({ key: REFRESH_KEY, value: token });
  }

  async clear(): Promise<void> {
    this.accessToken = null;
    await Preferences.remove({ key: REFRESH_KEY });
  }
}
